import React, { useState, useContext, useEffect, forwardRef } from "react";

import {
  Grid,
  Button,
  Card,
  Link,
  Typography,
  Breadcrumbs,
  TextField,
  IconButton,
  FormControlLabel,
  Checkbox,
  List,
} from "@material-ui/core";

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import GetAppIcon from "@material-ui/icons/GetApp";

import ReactExport from "react-data-export";

import { makeStyles } from "@material-ui/core/styles";

import FulfillmentContext from "../../context/fulfillment/FulfillmentContext";

import DropdownMenu from "./DropdownMenu";

const FulfillmentFilter = ({
  dateIndex,
  setDateIndex,
  rows,
  fileName,
  setFileName,
  setDateRange,
  column,
  setColumnList,
  state,
  setState,
}) => {
  const fulfillmentContext = useContext(FulfillmentContext);
  const { getUnfulfill, loading, unfulfillAdded } = fulfillmentContext;
  const [addIndex, setAddIndex] = useState(false);

  const [dateFromSelected, setDateFromSelected] = useState(
    new Date().setHours(0, 0, 0, 0)
  );
  const [dateToSelected, setDateToSelected] = useState(
    new Date().setHours(0, 0, 0, 0)
  );

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const useStyles = makeStyles((theme) => ({
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
    grid: {
      padding: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
  }));

  const classes = useStyles();

  const dateYYMMDD = (ISO) => {
    let ISO_split = ISO.split("T");
    let date_split = ISO_split[0].split("-");
    let year = parseInt(date_split[0]) - 2000;
    return year + date_split[1] + date_split[2];
  };

  const onDateSearch = () => {
    const date_from = new Date(
      new Date(dateFromSelected).setHours(8, 0, 0, 0)
    ).toISOString();
    const date_to = new Date(
      new Date(dateToSelected).setHours(32, 0, 0, 0)
    ).toISOString();
    if (dateIndex !== date_from + " " + date_to) {
      getUnfulfill(date_from, date_to);
      setDateIndex(date_from + " " + date_to);
      //Set file name
      const from = new Date(
        new Date(dateFromSelected).setHours(8, 0, 0, 0)
      ).toISOString();
      const to = new Date(
        new Date(dateToSelected).setHours(8, 0, 0, 0)
      ).toISOString();
      setFileName("fulfillment_" + dateYYMMDD(from) + "_" + dateYYMMDD(to));
      const fromDisplay = from.split("T");
      const toDisplay = to.split("T");
      setDateRange("Records from " + fromDisplay[0] + " to " + toDisplay[0]);
    }
  };

  const ErrorAlert = (message) => {
    setState((state) => ({
      ...state,
      error_message: message,
    }));
    setTimeout(() => {
      setState((state) => ({
        ...state,
        error_message: "",
      }));
    }, 3000);
  };

  const SuccessAlert = (message) => {
    setState((state) => ({
      ...state,
      success_message: message,
    }));
    setTimeout(() => {
      setState((state) => ({
        ...state,
        success_message: "",
      }));
    }, 3000);
  };

  const onOrderIDChange = (e) => {
    e.preventDefault();
    e.persist();

    if (e.target.id === "order_id") {
      const value = e.target.value.trim();
      setState((state) => ({
        ...state,
        [e.target.id]: value,
      }));
    }
  };

  const onAddRow = () => {
    let existed_list = [];
    let orderID = state.order_id.toUpperCase();
    if (orderID.indexOf("#") < 0) {
      orderID = "#" + orderID;
    }
    for (let x in rows) {
      existed_list.push(rows[x].order_id);
    }
    if (state.order_id === "") {
      ErrorAlert("Order ID can't be blanked");
    } else {
      if (existed_list.indexOf(orderID) < 0) {
        getUnfulfill("", "", orderID);
        setAddIndex(true);
      } else {
        ErrorAlert("Order ID already existed");
      }
    }
  };

  useEffect(() => {
    if (addIndex) {
      if (unfulfillAdded && unfulfillAdded.length > 0) {
        SuccessAlert("Row added successfully");
      } else {
        ErrorAlert("Order ID not found");
      }
      setAddIndex(false);
    }
  }, [unfulfillAdded]);

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      className={classes.grid}
    >
      <Grid item>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="normal"
                id="date_from"
                label="From"
                disabled={loading}
                autoOk={true}
                maxDate={new Date()}
                value={dateFromSelected}
                style={{
                  width: 160,
                }}
                onChange={(date) => setDateFromSelected(date)}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />{" "}
            </MuiPickersUtilsProvider>{" "}
          </Grid>{" "}
          <Grid item>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="normal"
                id="date_to"
                label="To"
                disabled={loading}
                autoOk={true}
                maxDate={new Date()}
                value={dateToSelected}
                style={{
                  width: 160,
                }}
                onChange={(date) => setDateToSelected(date)}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />{" "}
            </MuiPickersUtilsProvider>{" "}
          </Grid>{" "}
          <Grid item>
            <Button
              onClick={onDateSearch}
              disabled={
                loading || new Date(dateFromSelected) > new Date(dateToSelected)
              }
              variant="contained"
              color="primary"
              className={classes.buttonOutline}
            >
              Search{" "}
            </Button>{" "}
          </Grid>{" "}
          <Grid item>
            <DropdownMenu column={column} setColumnList={setColumnList} />{" "}
          </Grid>{" "}
          <Grid item>
            <TextField
              label="Add by Order ID"
              type="text"
              id="order_id"
              name="order_id"
              size="small"
              style={{
                width: 175,
              }}
              value={state.order_id}
              disabled={loading || addIndex}
              onChange={onOrderIDChange}
            />{" "}
          </Grid>{" "}
          <Grid item>
            <Button
              onClick={onAddRow}
              disabled={loading || addIndex}
              variant="contained"
              color="primary"
              className={classes.buttonOutline}
            >
              Add{" "}
            </Button>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>{" "}
      <Grid item>
        <ExcelFile
          filename={fileName}
          element={
            <Button
              disabled={loading}
              variant="contained"
              color="primary"
              className={classes.buttonOutline}
              startIcon={<GetAppIcon />}
            >
              Export{" "}
            </Button>
          }
        >
          <ExcelSheet data={rows} name="Fulfillment">
            <ExcelColumn label="Store Name" value="store_name" />
            <ExcelColumn label="Order ID" value="order_id" />
            <ExcelColumn label="SKU" value="sku" />
            <ExcelColumn label="Quantity" value="quantity" />
            <ExcelColumn label="Total Quantity" value="total_quantity" />
            <ExcelColumn label="Amount" value="amount" />
            <ExcelColumn label="Product Name" value="product_name" />
            <ExcelColumn label="Variant Title" value="variant_title" />
            <ExcelColumn label="Name" value="name" />
            <ExcelColumn label="Address" value="address" />
            <ExcelColumn label="City" value="city" />
            <ExcelColumn label="Province" value="province" />
            <ExcelColumn label="Country" value="country" />
            <ExcelColumn label="Zip" value="zip" />
            <ExcelColumn label="Phone" value="phone" />
            <ExcelColumn label="Email" value="email" />
            <ExcelColumn label="Date Ordered" value="date_ordered" />
            <ExcelColumn label="Shipping Cost" value="shipping_cost" />
            <ExcelColumn label="Product Cost" value="product_cost" />
          </ExcelSheet>{" "}
        </ExcelFile>{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default FulfillmentFilter;
